import { createAsyncThunk } from '@reduxjs/toolkit';
import { createBusinessContact } from '../services/createBusinessContact.service';
import {
  selectUserActiveEmployerBusinessId,
  selectUserActiveEmployerInfo,
} from 'store/user/selectors.js/user.selectors';

export const createBusinessContactThunk = createAsyncThunk(
  'contacts/createBusinessContact',
  async (contactData, { getState }) => {
    const state = getState();
    const businessId = selectUserActiveEmployerBusinessId(state);
    const activeEmployerInfo = selectUserActiveEmployerInfo(state);

    if (!businessId) {
      throw new Error('No business id given');
    }

    return await createBusinessContact(
      businessId,
      contactData,
      activeEmployerInfo
    );
  }
);
